<template>
    <div>
        <gj-modal
            v-bind="$attrs"
            v-on="$listeners"
            :visible.sync="modalVisible"
            :destroyOnClose="true"
            size="800_auto"
            @cancel="cancel(), $emit('close')"
            @confirm="submit"
            :confirm-loading="loading"
        >
            <template #header>{{id !== null ? '编辑用户' : '添加用户'}}</template>
            <template #content>
                <div
                    v-loading="userLoading || orgLoading || marketLoading || roleLoading"
                >
                    <el-form
                        :model="form"
                        :rules="formRules"
                        ref="ruleForm"
                        :label-position="'right'"
                        label-width="92px"
                    >
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="用户名" prop="userName">
                                    <gj-input
                                        :disabled="id !== null"
                                        v-model="form.userName"
                                        placeholder="请输入用户名"
                                        width="240px"
                                        auto-complete="new-password"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="真实姓名" prop="name" label-width="102px">
                                    <gj-input
                                        v-model="form.name"
                                        placeholder="请输入真实姓名"
                                        width="220px"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="手机号码" prop="phone">
                                    <gj-input
                                        :disabled="id !== null && isMain"
                                        v-model="form.phone"
                                        placeholder="请输入手机号码"
                                        width="240px"
                                    ></gj-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="邮箱" prop="email" label-width="102px">
                                    <gj-input
                                        v-model="form.email"
                                        placeholder="请输入邮箱"
                                        width="220px"
                                        auto-complete="new-password"
                                    >
                                    </gj-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <template v-if="id === null">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="password">
                                      <template #label>
                                        密码
                                        <gj-help font-size="12px">
                                          密码格式：必须同时包含字母和数字，且长度在6-20位字符之间，区分大小写
                                        </gj-help>
                                      </template>
                                        <gj-input
                                            type="password"
                                            v-model="form.password"
                                            placeholder="请输入包含字母和数字的6-20位字符"
                                            width="240px"
                                            auto-complete="new-password"
                                        >
                                        </gj-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="确认密码" prop="againPassword" label-width="102px">
                                        <gj-input
                                            type="password"
                                            v-model="form.againPassword"
                                            placeholder="请确认密码"
                                            width="220px"
                                            auto-complete="new-password"
                                        >
                                        </gj-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                        <template v-if="id !== null">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item prop="updatePassword">
                                      <template #label>
                                        密码
                                        <gj-help font-size="12px">
                                          密码格式：必须同时包含字母和数字，且长度在6-20位字符之间，区分大小写
                                        </gj-help>
                                      </template>
                                        <gj-input
                                            type="password"
                                            v-model="form.updatePassword"
                                            placeholder="请输入包含字母和数字的6-20位字符"
                                            width="240px"
                                            auto-complete="new-password"
                                        >
                                        </gj-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="确认密码" prop="updateAgainPassword" label-width="102px">
                                        <gj-input
                                            type="password"
                                            v-model="form.updateAgainPassword"
                                            placeholder="请确认密码"
                                            width="220px"
                                        >
                                        </gj-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="部门" prop="org">
                                    <gj-tree-select
                                        v-model="form.org"
                                        :data="orgData"
                                        width="240px"
                                    >
                                    </gj-tree-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-form-item label="角色" prop="roles">
                                <div class="roleDropDown">
                                    <gj-select
                                        multiple
                                        v-model="form.roles"
                                        width="612px"
                                        :options="roleData"
                                        :disabled="id !== null && isMain">
                                    </gj-select>
                                    <i  class="el-icon-setting Icon" :style="roleTip ? { display : 'inline-block'} : null"  @click="jump"></i>
                                </div>
                                <div>

                                </div>
                            </el-form-item>
                        </el-row>
                        <div>
                            <el-form-item label="店铺授权" prop="datas">
                                <template v-if="id !== null && isMain">
                                    所有店铺
                                </template>
                                <template v-else>
                                    <el-transfer
                                        style="text-align: left; display: inline-block"
                                        v-model="form.datas"
                                        filterable
                                        :titles="['未授权', '已授权']"
                                        :format="{
                                    noChecked: '(${total})',
                                    hasChecked: '(${checked}/${total})'
                                }"
                                        :data="allMarketPermission">
                                    </el-transfer>
                                </template>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="guide-all-one" v-if="roleTip">
                    <div  class="guidance-content">
                        <div>您需要为此账号选择一个角色，TA才可以使用系统功能哦~系统有提供默认的角色，您可以直接选择角色~如果默认角色不能满足您的需求，可以点击这里去管理角色哦~</div>
                        <gj-button
                            @click="roleTip = !roleTip, storeTip = true"
                            class="content-btn">
                            我知道了
                        </gj-button>
                    </div>
                    <div class="user-guide-point">
                        <div class="user-guider-line"></div>
                    </div>
                </div>
                <div class="guide-all-two" v-if="storeTip">
                    <div class="guidance-content">
                        <div>您需要为此账号授权店铺，TA才可以在系统查看对应店铺的数据哦~</div>
                        <gj-button
                            @click="storeTip = !storeTip"
                            class="content-btn">
                            我知道了
                        </gj-button>
                    </div>
                    <div class="user-guide-point">
                        <div class="user-guider-line"></div>
                    </div>
                </div>
            </template>
        </gj-modal>
    </div>
</template>

<script>
    import {modalMixIn, userGuideMixin} from "@/minxins";
    import {isBlank, isMeaningful, isNotBlank} from "@/utils/common";
    import {orgTree, queryRoleAll, queryShopAll, userDetail} from '@/api/setting';

    export default {
        name: "user-edit-modal",
        mixins: [modalMixIn, userGuideMixin],
        props: {
            id: null,
            isMain: null,
            orgId: null,
        },
        created() {
            if (isMeaningful(this.id)) {
                this.userLoading = true;
                userDetail(this.id)
                    .then((data) => {
                        this.form.id = data.id;
                        this.form.userName = data.userName;
                        this.form.name = data.name;
                        this.form.phone = data.phone;
                        this.form.email = data.email;
                        this.form.org = data.org;
                        this.form.roles = data.roles.map(v => v.id);
                        this.form.datas = (data.datas != null && data.datas.length > 0) ? data.datas.map(v => v.id) : [];
                        this.$nextTick(() => { this.$refs.ruleForm.clearValidate(); })
                    }).complete(() => this.userLoading = false)
            } else if (isMeaningful(this.orgId)) {
                this.form.org = this.orgId;
            }
            // 用户管理：部门结构树
            this.orgLoading = true;
            orgTree().then(response => {
                this.orgData = response.data;
            }).complete(() => this.orgLoading = false);
            // 角色：查询所有角色
            this.queryRole()

            // 站点：查询所有店铺信息
            this.marketLoading = true;
            queryShopAll().then(response => {
                const data = [];
                for (let i = 0; i < response.data.length; i++) {
                    const obj = response.data[i];
                    data.push({
                        key: obj.id,
                        label: obj.name + ':' + obj.countryCode,
                        disabled: false
                    });
                }
                this.allMarketPermission = data;
            }).complete(() => this.marketLoading = false)

        },
        data() {
            return {
                userLoading: false,
                orgLoading: false,
                marketLoading: false,
                roleLoading: false,
                form: {
                    id: null,
                    userName: '',
                    name: '',
                    phone: '',
                    email: '',
                    password: '',
                    againPassword: '',
                    updatePassword: '',
                    updateAgainPassword: '',
                    org: '',
                    // isCharge: 0,
                    roles: [],
                    datas: [],
                },
                formRules: {
                    userName: [
                        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
                        { min: 6, max: 12, message: '限制6-12个字符', trigger: 'blur' },
                        { validator: this.checkName, trigger: 'blur'}
                    ],
                    name: [
                        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
                        { min: 2, max: 20, message: '限制2-20个字符', trigger: 'blur' },
                        { validator: this.checkRealName, trigger: 'blur'}
                    ],
                    phone: [
                        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
                        { validator: this.checkPhone, trigger: 'blur'}
                    ],
                    email: [
                        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
                        { validator: this.checkEmail, trigger: 'blur'}
                    ],
                    password: [
                        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
                        // { min: 6, max: 20, message: '限制6-20个字符', trigger: 'blur' },
                        { validator: this.checkPassword, trigger: ['blur', 'change']}
                    ],
                    againPassword: [
                        { required: true, message: '不能为空', trigger: ['blur', 'change'] },
                        { validator: this.checkAgainPassword, trigger: ['blur', 'change'] }
                    ],
                    updatePassword: [
                        // { min: 6, max: 20, message: '限制6-20个字符', trigger: 'blur' },
                        { validator: this.checkPassword, trigger: ['blur', 'change']}
                    ],
                    updateAgainPassword: [
                        { validator: this.checkUpdateAgainPassword, trigger: ['blur', 'change'] }
                    ],
                    // org:[
                    //     { required: true, message: '请选择部门', trigger: ['blur', 'change'] },
                    // ]
                    roles: [
                        { required: true, message: '请选择角色', trigger: ['blur', 'change'] },
                    ],
                },
                allMarketPermission: [],
                orgData: [],
                roleData: [],
                loading: false,
                roleTip: false,
                storeTip: false
            }
        },
        methods: {
            // 角色：查询所有角色
            queryRole() {
                this.roleLoading = true;
                queryRoleAll().then(response => {
                    this.roleData = response.data || [];
                    // 内置品类
                    let preset = ['平台管理员', '运营/客服', '采购/物流', '财务']
                    let flag = this.roleData.find(item => !preset.includes(item.text))
                    this.roleTip = this.roleData.length == 0 || !isMeaningful(flag)
                }).complete(() => this.roleLoading = false);
            },
            jump  (){
                this.$router.replace('/setting/role')
            },
            checkName(rule, value, callback) {
                if (isNotBlank(value)) {
                    const regEn = /[`~!@#$%^&*()+=<>?:"{},.\\/;'[\] ]/im;
                    const regCn = /[·！#￥（）：；“”‘、，|《。》？、【】[\]]/im;
                    if (!isNaN(value)) {
                        callback(new Error('不能输入纯数字'));
                    } else if (regEn.test(value) || regCn.test(value)) {
                        callback(new Error('不能输入特殊字符与空格'));
                    }
                }
                callback();
            },
            checkRealName(rule, value, callback) {
                if (isNotBlank(value)) {
                    const regEn = / /im;
                    if (regEn.test(value)) {
                        callback(new Error('不能输入空格'));
                    }
                }
                callback();
            },
            checkPhone(rule, value, callback) {
                if (isNotBlank(value)) {
                    const reg = /^(\d{10}|\d{11})$/;
                    if (!reg.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    }
                }
                callback();
            },
            checkEmail(rule, value, callback) {
                if (isNotBlank(value)) {
                    const reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
                    if (!reg.test(value)) {
                        callback(new Error('请输入正确的邮箱'));
                    }
                }
                callback();
            },
            checkPassword(rule, value, callback) {
                if (isNotBlank(value)) {
                  //必须包含字母、数字，可以有（可有可没有）特殊字符  (x20是空格)
                  const reg = /^(?=.*\d)(?=.*[A-Za-z])[\x21-\x7e]{6,20}$/;
                    // const reg = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)\S{6,16}$/;
                    if (!reg.test(value)) {
                        callback(new Error('请输入格式正确的密码'));
                    }
                }
                callback();
            },
            checkAgainPassword(rule, value, callback) {
                if (isNotBlank(value)) {
                    if (isBlank(this.form.password)) {
                        callback(new Error('请输入密码'));
                    } else if (this.form.password !== value) {
                        callback(new Error('两次输入密码不一致'));
                    }
                } else if (isBlank(this.form.password)) {
                    callback(new Error('请先输入新密码'));
                } else {
                    callback(new Error('请输入重复密码'));
                }
                callback();
            },
            checkUpdateAgainPassword(rule, value, callback) {
                if (isNotBlank(value)) {
                    if (isBlank(this.form.updatePassword)) {
                        callback(new Error('请输入密码'));
                    } else if (this.form.updatePassword !== value) {
                        callback(new Error('两次输入密码不一致'));
                    }
                } else if (isNotBlank(this.form.updatePassword)) {
                    callback(new Error('请确认密码'));
                }
                callback();
            },
            submit() {
                if(this.formValidate()){
                    this.$emit('create', this._.cloneDeep(this.form));
                }
            },
            formValidate() {
                let formValid = false;
                this.$refs.ruleForm.validate((valid) => {
                    formValid = valid;
                });
                return formValid;
            },
        },
    }
</script>

<style lang="scss" scoped>
/deep/ .el-transfer-panel{
  width: 270px;
}
  /deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
    font-size: 12px;
    color: #666;
  }

  /deep/ .el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    font-size: 12px;
  }
  /deep/ .el-transfer-panel__list.is-filterable {
    height: 210px!important;
  }
  /deep/ .el-transfer-panel{
      border-radius: 2px;
  }
  /deep/ .el-icon-search{
    height: 100%;
  }
/deep/ .el-button{
    border-radius: 2px;
    .el-icon-arrow-left:before{
        content: "\e6dd";
    }
    .el-icon-arrow-right:before {
        content: "\e6dc";
    }
}
  /deep/.el-transfer-panel__filter{
    top:-1px;
  }
.Icon{
    margin-left:6px;
    font-size: 14px;
    display: none;
    cursor:pointer;
}
.roleDropDown:hover{
    .Icon{
        display:inline-block;
    }
}
.guide-all-one {
  position: absolute;
  left: 784px;
  top: 224px;
    .guidance-content {
        background: #4994fc;
        color: #fff;
        z-index: 1000;
        border-radius: 4px;
        width: 400px;
        padding: 8px;
        .content-btn {
            color: #fff;
            margin-left: 315px;
            border: #fff solid 1px;
            background: #4994fc;
            &:hover {
                background: #4c8bf2;
                border: #fff solid 1px;
            }
        }
    }
    .user-guide-point {
        width: 40px;
        position: absolute;
        left: -40px;
        top: 48%;
        .user-guider-line {
        width: 100%;
        height: 2px;
        background: #4994fc;
        &::before {
            // 小圆点在这里
            content: "";
            border: 1px solid #4994fc;
            background-color: #4994fc;
            display: inline-block; // 此句为css样式展示重点🏁
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            margin-top: -4px;
        }
        }
    }
}
.guide-all-two {
    position: absolute;
    left: 784px;
    top: 300px;
    .guidance-content {
        background: #4994fc;
        color: #fff;
        z-index: 1000;
        border-radius: 4px;
        width: 300px;
        padding: 8px;
    .content-btn {
        color: #fff;
        margin-left: 220px;
        border: #fff solid 1px;
        background: #4994fc;
        &:hover {
            background: #4c8bf2;
            border: #fff solid 1px;
        }
    }
    }
    .user-guide-point {
        width: 40px;
        position: absolute;
        left: -40px;
        top: 48%;
        .user-guider-line {
            width: 100%;
            height: 2px;
            background: #4994fc;
            &::before {
                // 小圆点在这里
                content: "";
                border: 1px solid #4994fc;
                background-color: #4994fc;
                display: inline-block; // 此句为css样式展示重点🏁
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                margin-top: -4px;
            }
        }
    }
}
</style>
